import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Checkbox } from "@emisgroup/ui-checkbox";
import { GetRulesAndFilters } from "@emisgroup/cohort-builder";
import { FormElement } from "@emisgroup/ui-form";
import { Button } from "../../Common/UI/Index";
import { ButtonVariantType } from "../../Common/UI/Types";
import { IRootState } from "../../../reducer/CombineReducer";
import { getOptOuts } from "./Helper";
import { OptOutSlice } from "./redux/Index";
import { ParentOptOutModes } from "./redux/Types";
import Edit from "~icons/ic/outline-edit";
import "./Style.scss";

/**
 * Responsible for the optOut component in tab
 * @returns View of the optOut component
 */
export const OptOut = (): JSX.Element => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const optOut = useSelector((state: IRootState) => state.optOut);
  const currentValues = optOut?.selectedOptOuts;
  const getOptOutsFromSessionStorage = getOptOuts();
  GetRulesAndFilters("feasibilityApp");
  const isViewMode = optOut.mode === ParentOptOutModes.VIEW;
  const isCreateMode = optOut.mode === ParentOptOutModes.CREATE;

  /**
   * Handler for optOut on change
   * @param val Checked optOut
   * @returns Selected ones
   */
  const HandleOnChange = (val: string) => (isChecked: boolean): void => {
    dispatch(OptOutSlice.actions.updateSelectedOptOuts({ value: val, checked: isChecked }));
  };

  /**
   * Method for making optOuts checked
   * @param val Logical value
   * @returns Boolean value
   */
  const checkedOptOuts = (val: string): boolean => {
    return currentValues?.some((item: string) => item === val);
  };

  /**
   * Method on clicking the edit in optOut tab
   */
  const optOutEdit = (): void => {
    dispatch(OptOutSlice.actions.setOptOutMode(ParentOptOutModes.EDIT));
  };

  return (
    <>
      <div className="ebt-optOut__edit">
        <Button
          variant={ButtonVariantType.FILLED}
          id="ebt-optOut-edit"
          onClick={optOutEdit}
          disabled={!isViewMode || isCreateMode}
        >
          <Edit title="edit" />
          {translate("Button.Edit")}
        </Button>
      </div>
      <div className="ebt-optOut__child">
        <div className="ebt-optOut__header">{translate("OptOut.OptOuts")}</div>
        <FormElement
          errorText={!currentValues?.length ? translate("OptOut.ErrorText") : ""}>
          {getOptOutsFromSessionStorage?.map((item: any, idx: number) => {
            return (
              <div className="ebt-optOut__split-checkbox" key={idx}>
                <Checkbox
                  key={idx}
                  value={item.value}
                  onChange={HandleOnChange(item.value)}
                  checked={checkedOptOuts(item.value)}
                  disabled={isViewMode}
                >
                  {item.text}
                </Checkbox>
              </div>
            );
          })}
        </FormElement>
      </div>
    </>
  );
};
